import config from "../config";
import {Util} from "baziigram";
import {dictionary} from "../constants"

export default client => {
    function call() {
        var fcmToken;

        if(typeof window !== 'undefined' && window.android)
        fcmToken=window.android.getToken();

        return client.post(config.app.service.apiUrls.FCMToken, {fcmToken} ).then(resp => {

            if (resp.status && (resp.status === 200 || resp.status === 204))
               return resp.data;

            throw new Error(resp.message || dictionary.serverError[Util.getLanguage()]);
        });
    }

    return call;
};
